import './css/glossary.scss';
import glossary from "../modulos/glossary/glossary";

/**
 * Si la página vista es un término de glosario, envía un "visto" al server para que incremente
 * el número de visitas (score).
 */
const upgradeScore = () => {
    const urlBase = new URL(document.location)
    if (!urlBase.pathname.match(/-t-\d+$/)) {
        return;
    }

    const url = urlBase.origin + urlBase.pathname + '/score';
    if ('sendBeacon' in navigator) {
        navigator.sendBeacon(url);
    }
}

export const loadDictionary = () => {
    glossary();
    upgradeScore();
}
